import { EditableOptionsFieldDefinition, FirmSettings } from "aderant-conflicts-models";
import React, { useEffect } from "react";
import { FieldProps } from "./Types/FieldProps";
import { PickList } from "@aderant/aderant-react-components";

type OptionsFieldProps = {
    field: EditableOptionsFieldDefinition;
    settingsData: Partial<FirmSettings.PageDataModel>;
} & FieldProps;

export function OptionsField(props: OptionsFieldProps): JSX.Element {
    if (props.field.format !== "dropdown") {
        throw new Error("Only dropdown format is supported for OptionsField");
    }

    //Resolve the allowed values for the different allowed value types to the correct format for the PickList component
    const pickListOptions = props.field
        .getAllowedValues(props.settingsData)
        .map((value) => (value.label && value.value ? { label: value.label, value: value.value } : { label: value.toString(), value: value }));

    const isDataValid = props.field.isDataValid(props.data, pickListOptions);

    //Reset the value if the current value is not in the allowed values (e.g. if dependent settings have changed, and the value is no longer valid)
    const currentLabelValuePair = isDataValid
        ? { label: props.field.getDisplayValue(props.data), value: props.data }
        : { label: props.field.getDisplayValue(props.field.defaultValue), value: props.field.defaultValue };

    //Trigger onChange if the data is not valid
    if (!isDataValid && props.data !== undefined) {
        props.onChange(currentLabelValuePair.value);
    }

    return (
        <PickList
            key={props.field.name}
            id={`${props.field.name}-options-${props.field.format}`}
            label={props.field.label}
            labelProps={props.field.pickListProps?.labelProps}
            //aria-label={props.field.pickListProps?.ariaLabel} // Pass aria-label to the PickList
            style={props.field.pickListProps?.style}
            value={{ label: currentLabelValuePair.label, value: currentLabelValuePair.value }}
            onChange={(e, labelValuePair) => props.onChange(labelValuePair?.value ?? props.field.defaultValue)}
            selectOptions={pickListOptions}
            disabled={props.isPagePersisting}
        />
    );
}
